import React from "react";
import IconButton from "@mui/material/IconButton";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { printBudgetSelectionPdf } from "../../utils/printBudgetPdf";

const BudgetPrintSelection = ({
  idsPresupuestos = [],
  proyectos = [],
  sx,
}) => {
  const handlePrint = async () => {
    if (!idsPresupuestos.length) return;
    try {
      await printBudgetSelectionPdf({ idsPresupuestos, proyectos });
    } catch (err) {
      console.error("Error al imprimir presupuestos:", err);
    }
  };

  return (
    <IconButton
      onClick={handlePrint}
      disabled={!idsPresupuestos.length}
      sx={sx}
    >
      <LocalPrintshopOutlinedIcon />
    </IconButton>
  );
};

export default BudgetPrintSelection;
